import {useLocation} from "react-router-dom";
import {useForm} from "react-hook-form";

const OrderForm = () => {
  
  const {state} = useLocation();
  const {register, getValues} = useForm()
  const onPayment = () => {
    // 사용자 쿠폰 결제시
    if (!getValues(`phoneNum`)) {
      return alert(`전화번호를 입력하세요.`);
    }
  }
  console.log(state);
  const SendToPhoneEle = () => {
    return (
      <div className={`sec`}>
        <div className={`form-group`}>
          <label className={`block`}>선물 받으실 분의 성함과 전화번호를 알려주세요.</label>
          <input className={`block`} {...register(`phoneNum`, {required: true})} type={`text`}/>
        </div>
        <div className={`coupon_info`}>
          <ul>
            <li>
              받으실 분의 전화번호로 링크와 쿠폰코드를 보내드려요.<br/>
              받으실 분이 회원가입 후 쿠폰 코드를 입력하시면 해당 회원분께 상품이 등록되요.
            </li>
            <li>
              아직 선물 받을 분의 정보를 모르시나요? 직접 전달드릴 수 있도록 우선 구매자분의 문자로 보내드릴깨요.
            </li>
          </ul>
        </div>
      </div>
    )
  }
  return (
    <>
      <div className={`content_wrap order_form`}>
        <div className={`section_wrap`}>
          <div className={`sec`}>
            {state?.plans}
          </div>
          <SendToPhoneEle/>
          <div className={`sec flex items-center justify-center`}>
            <button className={`btn btn-primary`} onClick={onPayment}>결제하기</button>
          </div>
        </div>
      </div>
    </>
  )
}
export default OrderForm;